module.exports = __webpack_public_path__ + "static/schaukel03-da65c04feb70b9dea43a4647ee8845e2.jpg";